import React from 'react';

const LoadingScreen = () => {
  return (
    <div className="min-h-screen bg-[#121212] flex flex-col items-center justify-center gap-8">
      {/* RTB Logo - Replace with your logo image */}
      <div className="relative w-32 h-32 flex items-center justify-center">
        <div className="absolute inset-0 bg-gradient-to-br from-[#FF6600] to-[#FF4500] rounded-lg animate-pulse opacity-20" />
        <div className="relative z-10 text-center">
          {/* Option 1: Image Logo */}
          <img src="/logo.png" alt="RTB Logo" className="w-24 h-24 object-contain" />
          
          {/* Option 2: Text Logo - Disabled in favor of image */}
          {/* <h1 className="text-5xl font-bold text-[#FF6600] font-heading tracking-tighter">RTB</h1>
          <p className="text-[#A1A1AA] text-xs mt-2 tracking-widest">RAISE THE BAR</p> */}
        </div>
      </div>

      {/* Loading Spinner */}
      <div className="relative w-16 h-16">
        <div className="absolute inset-0 bg-gradient-to-r from-[#FF6600] to-transparent rounded-full animate-spin" />
        <div className="absolute inset-2 bg-[#121212] rounded-full" />
        <div className="absolute inset-1 border-2 border-transparent border-t-[#FF6600] rounded-full animate-spin" />
      </div>

      {/* Loading Text */}
      <div className="text-center">
        <p className="text-[#A1A1AA] text-sm tracking-wider">Initializing</p>
        <div className="flex gap-1 justify-center mt-2">
          <span className="w-1 h-1 bg-[#FF6600] rounded-full animate-bounce" style={{ animationDelay: '0s' }} />
          <span className="w-1 h-1 bg-[#FF6600] rounded-full animate-bounce" style={{ animationDelay: '0.2s' }} />
          <span className="w-1 h-1 bg-[#FF6600] rounded-full animate-bounce" style={{ animationDelay: '0.4s' }} />
        </div>
      </div>

      {/* Messages during loading */}
      <div className="text-center mt-8">
        <p className="text-[#666] text-xs">Loading RTB Dashboard...</p>
        <p className="text-[#444] text-xs mt-2">Please wait</p>
      </div>
    </div>
  );
};

export default LoadingScreen;
